import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload-large",
  "use": "upload-large-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"upload-large\"><title>_upload-large</title><g id=\"upload-large_uplopad\"><path d=\"M32,2a6.0068,6.0068,0,0,1,6,6V32a6.0068,6.0068,0,0,1-6,6H8a6.0068,6.0068,0,0,1-6-6V8A6.0068,6.0068,0,0,1,8,2H32m0-2H8A8.0235,8.0235,0,0,0,0,8V32a8.0235,8.0235,0,0,0,8,8H32a8.0235,8.0235,0,0,0,8-8V8a8.0235,8.0235,0,0,0-8-8Z\" /><path d=\"M30,31H10a1,1,0,0,1,0-2H30a1,1,0,0,1,0,2Z\" /><path d=\"M26.7852,14.3685,20.71,8.2928a1.0065,1.0065,0,0,0-1.4193,0l-6.0758,6.0758a1,1,0,1,0,1.4141,1.4141L19,11.4163V24a1,1,0,0,0,2,0V11.4115l4.3711,4.3711a1,1,0,1,0,1.4141-1.4141Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/upload-large.svg
// module id = +ETy
// module chunks = 4